const indexMap = /* @__PURE__ */ new Map([
  ["suggestions", "suggestionsIndex"],
  ["stores", "storesIndex"],
  ["content", "contentIndex"]
]);
const mapSearchIndicesToRecord = (Indices) => {
  return Indices.reduce((prev, curr) => {
    const indexName = indexMap.get(curr.type);
    if (!indexName) {
      return prev;
    }
    return { ...prev, [indexName]: curr };
  }, {});
};
export {
  mapSearchIndicesToRecord
};
//# sourceMappingURL=map-search-indices-to-record.js.map
